export default {
    bodyTemperature: "تب",
    pulse: "نبض",
    leftHandBloodPressure: "فشار خون دست چپ",
    rightHandBloodPressure: "فشار خون دست راست"
}